import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import Api from "../../../../../initialpage/hooks/Api";
import useAuth from "../../../../../initialpage/hooks/useAuth";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import "./NewEntry.css";
import Cookies from "js-cookie";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const NewEntry = () => {
  const [fixedData, setFixedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [localStorageProducts, setLocalStorageProducts] = useState([]);
  const [productOption, setProductOption] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedUnit, setSelectedUnit] = useState({});
  const [supplierDate, setSupplierDate] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({});
  const [showupdateBtn, setShowupdateBtn] = useState([]);
  const [updatedQty, setUpdateQty] = useState(null);
  const user = JSON.parse(Cookies.get("user") || '{}');

  // get MRR Data
  const {
    data: MRRData,
    error,
    mutate,
  } = useSWR(`store/products/lastMrrNumber`, fetcher);
  // get supplierData
  const { data: supplierOption, error: error1 } = useSWR(
    `store/settings/suppliers?page=${0}&limit=${10000}`,
    fetcher1
  );
  // get categoryData
  const { data: categoryOption, error: error2 } = useSWR(
    `store/settings/categories?page=${0}&limit=${10000}`,
    fetcher1
  );

  // get UnitData
  const { data: unitOption, error: error3 } = useSWR(
    `store/settings/units?page=${0}&limit=${10000}`,
    fetcher1
  );

  // set supplier category select list
  let supplierCategory = [];
  if (supplierOption && supplierOption.length > 0) {
    supplierCategory = supplierOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.sup_id;
      optionsItem.label = `${data.supplier}`;
      return optionsItem;
    });
  }

  // set category select list
  let category = [];
  if (categoryOption && categoryOption.length > 0) {
    category = categoryOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.cat_id;
      optionsItem.label = `${data.categoryen} (${data.categorybn})`;
      return optionsItem;
    });
  }

  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.prodid;
      optionsItem.label = `${data.proname} & ${data.pronametwo}`;
      return optionsItem;
    });
  }

  // set Unit select list
  let unitCategory = [];
  if (unitOption && unitOption.length > 0) {
    unitCategory = unitOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.unit_id;
      optionsItem.label = `${data.unit}`;
      return optionsItem;
    });
  }
  // handle Unit select;
  const handleUnit = (name) => {
    setSelectedUnit(name);
  };

  // handle supplier select;
  const handleSupplier = (name) => {
    setSelectedSupplier(name);
  };

  // handle product select;
  const handleProduct = (product) => {
    setSelectedProduct(product);
  };

  // handle Category select;
  const handleCategory = (name) => {
    const id = name.value;

    setSelectedCategory(name.value);
    API.get(`store/products/newProductList/${id}`).then((res) =>
      setProductOption(res.data.data)
    );
  };

  // handle change Quantity Amount
  const changeQuantityAmount = (id, e) => {
    setShowupdateBtn([...showupdateBtn, "true", id]);
    const quantity = parseInt(e.target.value);
    setUpdateQty(quantity);
  };

  // react hook form
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = (data) => {
    const initial = {
      mrrnno: MRRData,
      supplier: selectedSupplier ? selectedSupplier : fixedData.supplier,
      suppdate: supplierDate ? supplierDate : fixedData.suppdate,
      workorder: data.WORK_ORDER_NUMBER
        ? data.WORK_ORDER_NUMBER
        : fixedData.workorder,
      workodate: data.WORK_ORDER_DATE
        ? data.WORK_ORDER_DATE
        : fixedData.workodate,
      cashmemono: data.CASH_MEMO_NO ? data.CASH_MEMO_NO : fixedData.cashmemono,
      cashmemodate: supplierDate ? supplierDate : fixedData.cashmemodate,
      username: user?.name_english,
    };

    localStorage.setItem("FixedData", JSON.stringify(initial));

    const { value } = selectedProduct;
    const found = localStorageProducts.find(
      (item) => item.prod_list_id === value
    );
    if (found) {
      window.alert("Product already in cart");
    } else {
      const split = selectedProduct?.label?.split("&");

      setLoading(true);
      const newProduct = {
        prod_list_id: parseInt(selectedProduct.value),
        proname: split[0],
        pro_name_two: split[1],
        qty: parseInt(data.QUANTITY),
        price: parseInt(data.AMOUNT),
        category: parseInt(selectedCategory),
        prod_unit: parseInt(selectedUnit.value),
        show_unit: selectedUnit.label,
        stock_alert: parseInt(data.ALERT_QUANTITY),
      };
      setLocalStorageProducts([...localStorageProducts, newProduct]);
      const newArray = [...localStorageProducts, newProduct];
      localStorage.setItem("items", JSON.stringify(newArray));
      reset();
    }
  };

  const deleteProduct = (id) => {
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const remaining = localStorageProducts.filter(
        (product) => product.prod_list_id !== id
      );
      setLocalStorageProducts(remaining);
      localStorage.setItem("items", JSON.stringify(remaining));
    }
  };

  //  localStorage.setItem("item123", "tariq");
  const [buttonLoading, setButtonLoading] = useState(false);

  //   Handle Submit
  const handleRequest = () => {
    setButtonLoading(true);

    if (localStorageProducts.length > 0) {
      let localFixed = localStorage.getItem("FixedData")
        ? JSON.parse(localStorage.getItem("FixedData"))
        : {};
      localFixed["products"] = localStorageProducts;
      localFixed.supplier = localFixed.supplier.value;
      console.log(localFixed);
      API.post("store/products/productEntriesList", localFixed).then((res) => {
        console.log(res);
        if (!res.data.error) {
          swal({
            title: "Thank You !",
            text: "Successfully Added",
            icon: "success",
            button: "Ok",
          });
          PostStoreLog(1, "New store product Entry");
          setLoading(true);
          setButtonLoading(false);
          mutate();

          localStorage.setItem("items", JSON.stringify([]));
          localStorage.setItem("FixedData", JSON.stringify({}));
        }
      });
    } else {
      swal({
        title: "OPPS !",
        text: "No products found",
        icon: "error",
        button: "Ok",
      });
      setButtonLoading(false);
    }
  };
  const handleResetData = () => {
    const confirmReset = window.confirm(
      "Are you sure you want to reset all data? This action cannot be undone."
    );
    if (confirmReset) {
      localStorage.setItem("items", JSON.stringify([]));
      localStorage.setItem("FixedData", JSON.stringify({}));
      alert("Data has been reset.");
      window.location.reload();
    }
  };

  useEffect(() => {
    const localProducts = localStorage.getItem("items")
      ? JSON.parse(localStorage.getItem("items"))
      : [];
    setLocalStorageProducts(localProducts);

    const localFixedData = localStorage.getItem("FixedData")
      ? JSON.parse(localStorage.getItem("FixedData"))
      : {};
    setFixedData(localFixedData);
    setLoading(false);
  }, [loading]);

  // update temporary state
  const updateProduct = (id) => {
    const fil = localStorageProducts.map((item) => {
      let myItem = item;
      if (item.prod_list_id === parseInt(id)) {
        myItem.qty = updatedQty;
      }
      return myItem;
    });

    localStorage.setItem("items", JSON.stringify(fil));
    setShowupdateBtn([]);
    swal({
      title: "Thank You !",
      text: "Successfully Updated",
      icon: "success",
      button: "Ok",
    });
  };

  return (
    <>
      <Helmet>
        <title>New Product Entry - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Create/Entry Products To Office Store
            </h3>
            <button
              className="bg-black text-white"
              onClick={() => handleResetData()}
            >
              Reset Data
            </button>
          </div>

          <div
            style={{ background: "white", borderRadius: "10px" }}
            className="p-3"
          >
            <div className="add_category py-5">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4 mt-1">
                    <label htmlFor="Supplier">
                      MRR Number <span className="color-red">*</span>
                    </label>
                    <input
                      defaultValue={MRRData}
                      type="text"
                      className="input-field-new p-2"
                      readOnly
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mt-1">
                    <label htmlFor="Supplier">
                      Supplier <span className="color-red">*</span>
                    </label>

                    <Select
                      isDisabled={fixedData.supplier ? true : false}
                      onChange={handleSupplier}
                      placeholder={
                        fixedData.supplier ? fixedData.supplier.label : "Select"
                      }
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={supplierCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedSupplier}
                      required={fixedData.supplier ? false : true}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mt-1">
                    <label htmlFor="To_Date">
                      Supplier Date <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.suppdate ? true : false}
                      defaultValue={
                        fixedData.suppdate ? fixedData.suppdate : ""
                      }
                      onChange={(e) => setSupplierDate(e.target.value)}
                      type="date"
                      className="p-2 input-field-new"
                      required
                    />
                  </div>
                </div>

                <div className="row mt-5">
                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="Supplier">
                      Work Order Number <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.workorder ? true : false}
                      defaultValue={
                        fixedData.workorder ? fixedData.workorder : ""
                      }
                      {...register("WORK_ORDER_NUMBER")}
                      type="text"
                      className="input-field-new p-2"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="work_order">
                      Work Order Date <span className="color-red">*</span>
                    </label>
                    <input
                      readOnly={fixedData.workodate ? true : false}
                      defaultValue={
                        fixedData.workodate ? fixedData.workodate : ""
                      }
                      {...register("WORK_ORDER_DATE")}
                      type="date"
                      className="p-2 input-field-new"
                      required
                    />
                  </div>
                </div>

                <div className="row mt-5">
                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="Cash_memo">
                      Cash Memo/Bill No. <span className="color-red">*</span>
                    </label>
                    <input
                      cashmemono
                      readOnly={fixedData.cashmemono ? true : false}
                      defaultValue={
                        fixedData.cashmemono ? fixedData.cashmemono : ""
                      }
                      {...register("CASH_MEMO_NO")}
                      type="text"
                      className="input-field-new p-2"
                      required
                    />
                  </div>
                  <div className="col-12 col-md-4 col-lg-6">
                    <label htmlFor="cash_memo_date">
                      Cash Memo/Bill Date <span className="color-red">*</span>
                    </label>
                    <input
                      type="date"
                      defaultValue={
                        fixedData.cashmemodate
                          ? fixedData.cashmemodate
                          : supplierDate
                      }
                      className="p-2 input-field-new"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12 col-md-4 col-lg-6">
                    <label htmlFor="product_category">
                      Category <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleCategory}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={category}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedCategory}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-4 col-lg-6">
                    <label htmlFor="product_name">
                      Product Name <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleProduct}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={productCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedProduct.value}
                      required
                    />
                  </div>
                </div>

                <div className="row mt-5">
                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="quantity">
                      Quantity <span className="color-red">*</span>
                    </label>
                    <input
                      {...register("QUANTITY")}
                      type="number"
                      className="input-field-new p-2"
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="Amount">
                      Each Quantity Amount <span className="color-red">*</span>
                    </label>
                    <input
                      {...register("AMOUNT")}
                      type="number"
                      min={1}
                      className="input-field-new p-2"
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="alert_quantity">
                      Alert Quantity <span className="color-red">*</span>
                    </label>
                    <input
                      {...register("ALERT_QUANTITY")}
                      type="number"
                      className="input-field-new p-2"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="Unit" className="">
                      Unit <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleUnit}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={unitCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={selectedUnit.value}
                      required
                    />
                  </div>
                </div>
                <button type="sumbit" className="mt-5 px-4 btn btn-color_store">
                  <i className="fa fa-plus"></i>
                  <span> Add</span>
                </button>
              </form>

              {/* Table */}
              <div className="row mt-5">
                <div className="col-12">
                  <div id="printArea" className="table-responsive-sm">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr className="tableColor">
                          <th>S/N</th>
                          {/* <th>Supplier</th> */}
                          <th>Name</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Total</th>
                          <th>Unit</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {localStorageProducts.length > 0 &&
                          localStorageProducts.map((product, index) => {
                            const {
                              prod_list_id,
                              proname,
                              pronametwo,
                              qty,
                              price,
                              category,
                              show_unit,
                            } = product;
                            return (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                {/* <td>{supplier}</td> */}
                                <td>{proname}</td>
                                <td className="text-center">
                                  <input
                                    type="number"
                                    onChange={(e) =>
                                      changeQuantityAmount(prod_list_id, e)
                                    }
                                    defaultValue={qty}
                                    style={{
                                      width: "60px",
                                      paddingLeft: "5px",
                                    }}
                                    className="input-field-new"
                                  />
                                </td>
                                <td className="text-center">{price}</td>
                                <td className="text-center">
                                  {(qty * price).toFixed(2)}
                                </td>
                                <td>{show_unit}</td>

                                <td>
                                  <button
                                    onClick={() => deleteProduct(prod_list_id)}
                                    data-bs-toggle="tooltip"
                                    title="Delete"
                                    type="button"
                                    className="btn btn-red px-3"
                                  >
                                    <i className="fa fa-times fs-6"></i>
                                  </button>
                                  {showupdateBtn[0] === "true" &&
                                    showupdateBtn[1] === prod_list_id ? (
                                    <button
                                      onClick={() =>
                                        updateProduct(prod_list_id)
                                      }
                                      data-bs-toggle="tooltip"
                                      title="update"
                                      type="button"
                                      className="btn btn-outline-color_store bg-primary text-white px-3 ms-3"
                                    >
                                      <i className="fa fa-check fs-6"></i>
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {!buttonLoading ? (
                <button
                  onClick={handleRequest}
                  className="btn btn-color_store px-3 mt-4"
                >
                  <i className="fa fa-check" />
                  <span> Submit</span>
                </button>
              ) : (
                <button className="btn btn-color_store px-3 mt-4">
                  <i className="fa fa-check" />
                  <span> Submit</span>

                  <div
                    style={{ width: "20px", height: "20px" }}
                    class="spinner-border ms-2  text-light"
                    role="status"
                  >
                    <span style={{}} class="visually-hidden ">
                      Loading...
                    </span>
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewEntry;
